var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlightVerticalDirectionMany(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "108px",
    viewBox: "0 0 12 108",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "35F2C3A3-4ADE-458F-AD53-822C953EB740") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Summary",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "All-flight-connectors",
    transform: "translate(-56, -49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FlightConnector/Vertical/Medium/2Transfers",
    transform: "translate(56, 49)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 2,
    x2: 6,
    y2: 105,
    id: "Line",
    stroke: "#2800A0",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    fill: "#2800A0",
    cx: 6,
    cy: 3,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#2800A0",
    cx: 6,
    cy: 105,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-4",
    fill: "#2800A0",
    cx: 6,
    cy: 42,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-5",
    fill: "#2800A0",
    cx: 6,
    cy: 62,
    r: 6
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlightVerticalDirectionMany);
export default __webpack_public_path__ + "static/media/flight-vertical-direction-many.c939cb1334600682f4d4763ac45e7cf6.svg";
export { ForwardRef as ReactComponent };